import script from "./LiveTypeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveTypeDialog.vue?vue&type=script&setup=true&lang=js"

import "./LiveTypeDialog.vue?vue&type=style&index=0&id=1b529b0c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b529b0c"]])

export default __exports__